import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAppBar,{staticClass:"leaveBar mb-2",staticStyle:{"background-color":"#f0f3f4"},style:({ border: '0' }),attrs:{"dense":""}},[_c('div',{staticClass:"text-lg-h5",staticStyle:{"font-weight":"300"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c(VSpacer),_c(VBreadcrumbs,{attrs:{"customDivider":"","divider":"/","large":"","items":_vm.path}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }